module.exports = __webpack_public_path__ + "donut.03ab92ed2c39af04ed90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/donut.png
// module id = ./src/assets/donut.png
// module chunks = main